import {
  prop,
  pick
} from "ramda";

const SeatsSerialize = {
  order: Infinity,
  run($$) {
    $$.seatsDataSerialize = () =>
      R.pipe(
        R.map((seat) => {
          const coordinates = prop("coordinates", seat);
          let newSeat = pick(["type", "status", "row", "seat", "x", "y"], seat);
          if (coordinates) {
            newSeat = Object.assign(newSeat, coordinates);
          }
          return newSeat;
        }),
        JSON.stringify
      )($$.seatsData.seats);
  },
};

window.SectionSeatsSerialize = SeatsSerialize;

export default SeatsSerialize;
